export const SITE_URL = 'https://www.suriyaprakash.in'

export function hasMarkdownPage(path: string) {
  const normalized = path.replace(/\/$/, '') || '/'
  return (
    [
      '/',
      '/work',
      '/playground',
      '/blog',
      '/blog/tag',
      '/playground/datatable',
      '/playground/schemaform',
      '/playground/querybuilder',
    ].includes(normalized) ||
    /^\/work\/(vetnest|indian-context|my-clinic|packcraft-india)$/.test(
      normalized,
    ) ||
    /^\/blog\/[^/.]+(?:\/[^/.]+)?$/.test(normalized)
  )
}

export function markdownPath(path: string) {
  const [pathname, query] = path.split('?')
  return `${pathname === '/' ? '/index.md' : `${pathname.replace(/\/$/, '')}.md`}${query ? `?${query}` : ''}`
}

export function htmlPath(path: string) {
  if (path === '/index.md') return '/'
  return path.endsWith('.md')
    ? path.slice(0, -3)
    : path.replace(/\/$/, '') || '/'
}

// Require an explicit Markdown preference; wildcards remain HTML by default.
export function wantsMarkdown(accept: string | null) {
  const ranges = (accept ?? '')
    .toLowerCase()
    .split(',')
    .map((range) => {
      const [type, ...params] = range.trim().split(';')
      const quality = params.find((p) => p.trim().startsWith('q='))
      const q = quality ? Number(quality.trim().slice(2)) : 1
      return {
        type: type.trim(),
        q: Number.isFinite(q) && q >= 0 && q <= 1 ? q : 0,
      }
    })
  const markdown = ranges.find((r) => r.type === 'text/markdown')?.q ?? 0
  const html =
    ranges.find((r) => r.type === 'text/html')?.q ??
    ranges.find((r) => r.type === 'text/*')?.q ??
    ranges.find((r) => r.type === '*/*')?.q ??
    0
  return markdown > 0 && markdown >= html
}

export async function markdownResponse(
  request: Request,
  markdown: string | undefined,
  canonicalPath: string,
) {
  const body =
    markdown === undefined
      ? '# 404 — Page not found\n'
      : `${markdown.trimEnd()}\n`
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(body),
  )
  const etag = `"${Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('')}"`
  const headers = new Headers({
    'Content-Type': 'text/markdown; charset=utf-8',
    'Cache-Control':
      markdown === undefined ? 'no-store' : 'public, max-age=3600',
    Vary: 'Accept',
    ETag: etag,
    'X-Content-Type-Options': 'nosniff',
    'x-markdown-tokens': String(Math.ceil(body.length / 4)),
  })
  if (markdown === undefined || /^robots: "noindex, follow"$/m.test(markdown))
    headers.set('X-Robots-Tag', 'noindex, follow')
  if (markdown !== undefined)
    headers.set('Link', `<${SITE_URL}${canonicalPath}>; rel="canonical"`)
  const matches = (request.headers.get('if-none-match') ?? '')
    .split(',')
    .some(
      (value) =>
        value.trim().replace(/^W\//, '') === etag || value.trim() === '*',
    )
  const status = markdown === undefined ? 404 : matches ? 304 : 200
  return new Response(
    request.method === 'HEAD' || status === 304 ? null : body,
    { status, headers },
  )
}
